<template>
  <div class="result-list">
    <div class="sport" v-for="sport in sports" :key="sport.id" v-show="!$route.params.sport || $route.params.sport == sport.id">
      <div class="sport-hat">
        <sport-icon-liga-white :name="sport.alias" />
        <div class="sport-name">{{ sport.name }}</div>
      </div>
      <div class="leagues" style="margin-top:10px;">
        <div class="league" v-for="league in sport.leagues" :key="league.id" v-show="!$route.params.league || $route.params.league == league.id">
          <div class="league-hat">
            <country-icon class="country-icon" v-if="league.country" :code="league.country.code" :name="league.country.name" />
            <div class="league-name" style="margin-left: 34px;" v-if="!league.country">{{ league.name }}</div>
            <div class="league-name" v-if="league.country">{{ league.name }}</div>
          </div>
          <div class="events">
            <event v-for="event in league.events" :key="event.id" :event="event" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import CountryIcon from '@/components/icons/CountryIcon'
import Event from '@/components/results/list/Event'
import { mapState } from 'vuex'

export default {
  components: { SportIconLigaWhite, CountryIcon, Event },
  computed: {
    ...mapState({
      sports: state => state.results.sports
    })
  }
}
</script>

<style scoped>
.result-list { margin: 10px; }
.sport-hat { display: flex; font-size: 20px; height: 40px; line-height: 37px; margin-bottom: -10px; }
.sport-icon-liga-white { margin: 8px 3px 12px 5px; }
.league-hat { display: flex; height: 40px; line-height: 40px; background: rgba(117,80,118,.1) !important; border-radius: 10px; color: #231e4a; }
.country-hat { display: flex; height: 40px; line-height: 40px; background: rgba(117,80,118,.2) !important; border-radius: 10px; color: #231e4a; }
.country-icon { flex-shrink: 0; margin-left: -7px; }
.countries { margin-top: 10px; }
.league-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-left: 10px; }
.sport-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.country-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.events .event:not(:first-child) { margin-top: 1px; }
</style>



// WEBPACK FOOTER //
// src/components/results/list/List.vue